<template>
  <div class="core-manager">
    <el-breadcrumb class="admin-path" separator-class="el-icon-arrow-right">
      <el-breadcrumb-item>系统管理</el-breadcrumb-item>
      <el-breadcrumb-item>核心组维护</el-breadcrumb-item>
    </el-breadcrumb>
    <div class="container">
      <el-form :inline="true" :model="searchParams" class="search-form">
        <!-- <el-form-item  label="审批状态">
          <el-select  size="mini" v-model="currentastates" style="width:120px;" filterable placeholder="授权状态">
                  <el-option
                      v-for="item in authstates"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>
        </el-form-item> -->

        <el-form-item label="核心组(Core group)">
          <el-input size="mini"  v-model="searchParams.core_id"></el-input>
        </el-form-item>    

        <!-- <el-form-item label="是否公开">
          <el-checkbox size='mini' v-model="checkedisopen"></el-checkbox>
        </el-form-item> -->
        <el-form-item>
          <el-button size='mini' type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button size='mini'  @click="coreinsert">新增</el-button>
        </el-form-item>
      </el-form>
      <!-- <div>
        <el-button
              class="download-all"
              type="text"
              size="small">
              批量下载
        </el-button>
        <el-button
              class="apply-all"
              type="text"
              size="small">
              批量申请
        </el-button>
      </div> -->
      <el-table
        :data="list"
        style="width: 100%">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column
          prop="ind"
          label="ID"
          v-if="false">
        </el-table-column>
        <el-table-column
          prop="core_id"
          label="核心组">
        </el-table-column>
        <el-table-column
          prop="type"
          label="类别">
        </el-table-column>
        <el-table-column
          prop="name"
          label="姓名">
        </el-table-column>
        <el-table-column
          prop="email"
          label="邮箱">
        </el-table-column>
    
        <el-table-column
          width="150"
          label="操作">
          <template slot="header" slot-scope="">
            <!-- <el-button
              class="download-all"
              type="text"
              size="small">
              批量下载
            </el-button>
            <el-button
              class="apply-all"
              type="text"
              size="small">
              批量申请
            </el-button> -->
          </template>
          <template slot-scope="scope">

            <!-- <el-link type="primary" :href="`/download/${scope.row.idai}`" target="_blank">下载</el-link> -->

            <el-button
              class="copy-btn"            
              :data-clipboard-text="scope.row"
              type="text"
              size="small"
              @click="CoreEdit(scope.row)">
              编辑
            </el-button>

            <el-button
              class="copy-btn"
              :data-clipboard-text="scope.row.ind"
              type="text"
              size="small"
              @click="CoreDelete(scope.row.ind)">
              删除
            </el-button>        
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        background
        layout="total, sizes, prev, pager, next, jumper"
        :current-page.sync="currentPage"
        :page-size.sync="pageSize"
        :total="total"
        @size-change="sizeChange"
        @current-change="changePage">
      </el-pagination>

      <el-dialog title="新增核心组成员" :visible.sync="coreIsVisible" @close="closeCoreInsertDialog">
        <el-form :model="coreForm" label-position="right">
          <el-form-item label="核心组">
            <el-input v-model="coreForm.core_id" autocomplete="off" placeholder="例：1,2,3...或者为空"></el-input>
          </el-form-item>
          <el-form-item label="人员类别">
            <el-select style="width:100%;"  v-model="coreForm.type"  
            filterable placeholder="选择人员类别（首席科学家、组长、副组长、组员）" autocomplete="off">
                  <el-option
                      v-for="item in coretype"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                  </el-option>
            </el-select>          
          </el-form-item>
          <el-form-item label="姓名">
            <el-input v-model="coreForm.name" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="邮件地址">
            <el-input v-model="coreForm.coremail" autocomplete="off"></el-input>
          </el-form-item>        
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeCoreInsertDialog">取消</el-button>
          <el-button type="primary" @click="confirmCoreInsertDialog">确定</el-button>
        </div>
      </el-dialog>

      <CoreEditDialog
        :dialog-visible="CoreEditIsVisible"
        :dialog-data="currentDataId"
        @ok="confirmCoreEditDialog"
        @close="closeCoreEditDialog">
      </CoreEditDialog>
    </div>
  </div>
</template>

<script>
import {AuthStates} from '../common';
import {CoreType} from '../common';
import axios from 'axios';
import CoreEditDialog from './CoreEditDialog.vue';

export default {
  name: 'CoreManager',
  components: {
    CoreEditDialog,
  },
  data() {
    return {
      searchParams: {
        proposal: '',
        startTime: '',
        endTime: '',
      },
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      checkedisopen:false,
      // checkedisstate:false,
      authstates: AuthStates,
      currentastates: '',
      coretype:CoreType,
      coreIsVisible: false,
      coreForm: {
        core_id:'',
        type:'',
        name: '',
        coremail: '',       
      },
      //修改窗口：参数
      CoreEditIsVisible:false,
      currentDataId: null,
    };
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      const params = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        datastatus: this.currentastates,
        dataproc: this.checkedisstate,
        ...this.searchParams,
      }
      axios.post('/iapi/coremanager', params).then((res) => {
        if (res.data.errcode === 0) {
          this.total = res.data.data.total;
          this.list = res.data.data.list;
        }
      });
      // console.log("authstates在这里",this.currentastates);
    },
    changePage(page) {
      this.currentPage = page;
      this.getData();
    },
    sizeChange() {
      this.getData();
    },
    onSubmit() {
      this.currentPage = 1;
      this.getData();
    },
    coreinsert(){
      this.coreIsVisible = true;
      this.coreForm.core_id = '';
      this.coreForm.type = '';
      this.coreForm.name = '';
      this.coreForm.coremail = '';
    },
    confirmCoreInsertDialog(){
      this.closeCoreInsertDialog();
      const params = {
        ...this.coreForm,
      };
      axios.post('/iapi/coreinsert', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('新增核心组成员成功！');
        }
      });
      this.getData();
    },
    closeCoreInsertDialog() {
      // console.log('取消');
      this.coreIsVisible = false;
    },
    CoreEdit(dataId) {
      // console.log('行数据在这里！',dataId);
      this.currentDataId =  dataId;
      this.CoreEditIsVisible = true;      
    },
    closeCoreEditDialog() {
      // console.log('取消');
      this.CoreEditIsVisible = false;
    },

    confirmCoreEditDialog(data) {
      // console.log('编辑确定在这里', data);
      this.closeCoreEditDialog();
      const params = {
        name:data.name,
        ind:data.ind,
        core_id:data.core_id,
        mail:data.mail,
        type:data.type,
      }
      axios.post('/iapi/coreedit', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('编辑核心组成员信息成功！');
        }
      });
      this.getData();
    },
    CoreDelete(dataId) {
      const params = {
        data_id: dataId,
      };
      axios.post('/iapi/coredelete', params).then((res) => {
        if (res.data.errcode === 0) {
          this.$message('删除核心组成员');
        }
      });
      this.getData();
    },
  },
};
</script>

<style scoped>
.core-manager {
  padding: 24px 56px;
}
.container {
  background: #fff;
  border-radius: 2px;
}
.search-form {
  padding-left: 16px;
  padding-right: 16px;
  padding-top: 8px;
  padding-bottom: 8px;
}
.el-form-item {
    color: blue;
    margin-top: 0px;
    margin-bottom: 0px;
}
.admin-path {
  margin-bottom: 16px;
}
</style>